import React from "react";
import { connect } from "react-redux";
import { Button } from "devextreme-react";
import { doGetExcel, setValidationOpening, setNameConflictModal, openCloseModalDeleteOpening, openCloseModalEditWeek } from "../actions";


class TooltipBody extends React.PureComponent {
  handleDownloadFile = () => {
    if (this.props.validationOpening.quotes > 0) {
      this.props.dispatch(doGetExcel());
    } else {
      this.props.dispatch(setValidationOpening({
        quotes: 0,
        openValidation: false,
      }));
    }
    this.props.dispatch(setNameConflictModal(false));
    if (this.props.isOpenModalDeleteOpening === true) {
      this.props.dispatch(openCloseModalDeleteOpening(false, null));
    }
    if (this.props.isOpenModalEditWeek === true) {
      this.props.dispatch(openCloseModalEditWeek(false, { config: {} }));
    }
  }
  render() {
    const { Opening, validationOpening } = this.props;
    return (

      <div
        className="row"
        style={{
          display: "flex", textAlign: "center", height: 115, alignItems: "center",
        }}
      >

        {validationOpening.quotes === 0 && (Opening.Id === 0 || Opening.Id > 0) && (
          <div>
            <div className="col-12">
              <h4> {validationOpening.message}  </h4>
            </div>

          </div>
        )}
        {Opening.Id === 0 && validationOpening.quotes > 0 && (
          <div>
            <div className="col-12">
              <h4> No se puede crear la apertura ya que existen <span style={{ color: "red" }} > {validationOpening.quotes} cupos agendados </span>
              </h4>
            </div>
            <div className="col-12">
              <h4>Primero debes resolver los conflictos removiendo estos cupos para poder crear la apertura  </h4>
            </div>
          </div>

        )}
        {Opening.Id > 0 && validationOpening.quotes > 0 && (
          <div>
            <div className="col-12">
              <h4>  No se puede editar la apertura ya que existen <span style={{ color: "red" }}> {validationOpening.quotes} cupos agendados </span>
              </h4>
            </div>
            <div className="col-12">
              <h4>  Primero debes resolver los conflictos removiendo estos cupos para poder editar la apertura </h4>
            </div>
          </div>
        )}

        <div
          className="col-12"
          style={{
            position: "fixed",
            textAlign: "center",
            left: 0,
            right: 0,
            bottom: 20,
          }}
        >
          <Button
            onClick={this.handleDownloadFile}
            type="success"
            width={130}
            text={validationOpening.quotes > 0 ? "Descargar Informe y volver" : "Cerrar"}
          />

        </div>

      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  Opening: state.aperturasSel.Opening,
  validationOpening: state.aperturasSel.validationOpening,
  isOpenModalDeleteOpening: state.aperturasSel.isOpenModalDeleteOpening,
  isOpenModalEditWeek: state.aperturasSel.isOpenModalEditWeek,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(TooltipBody);
